import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { PageContainerService, BrowserNavigateService } from './services';
import { NavigationEnd } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { SidebarComponent } from './components';
import * as $ from 'jquery';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {

  previousUrl: string = "";
  isSidebarCollapsed: boolean = false;
  
  constructor(public pcs: PageContainerService,
    private platformLocation: PlatformLocation,
    private browserNavigateService: BrowserNavigateService) {
    this.platformLocation.onPopState(() => {
      this.browserNavigateService.navigatedBack = true;
    });
    pcs.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        //on navigation changed (in case navigation changing without running a command to clear out the notifications/validation results)
        this.browserNavigateService.reset();
        this.pcs.handleNavigationEnd();
        if (this.navigationIsPageChange(val.url)) {
          //do stuff that needs to happen on url change here
        }
        this.previousUrl = val.url;
      }
    });
  }

  navigationIsPageChange(newUrl: string): boolean {
    var newUrlWithoutQueryParams = this.removeQueryParams(newUrl);
    var previousUrlWithoutQueryParams = this.removeQueryParams(this.previousUrl);
    if (newUrlWithoutQueryParams.toLowerCase() != previousUrlWithoutQueryParams.toLowerCase()) {
      return true;
    } else {
      return false;
    }
  }

  removeQueryParams(url: string): string {
    var indexOfQueryParams = url.indexOf("?");
    var urlWithoutQueryParams = url;
    if (indexOfQueryParams > -1) {
      urlWithoutQueryParams = url.substring(0, indexOfQueryParams);
    }
    urlWithoutQueryParams = urlWithoutQueryParams.replace(/[0-9]/g, '');
    return urlWithoutQueryParams;
  }

  ngOnInit() {
    if (!this.pcs.clientSessionService.loggedIn) {
      this.pcs.clientSessionService.reset();
    }
    // Restore sidebar collapsed state from localStorage
    const collapsed = localStorage.getItem('globalSidebarCollapsed');
    if (collapsed !== null) {
      this.isSidebarCollapsed = collapsed === 'true';
    }
    this.setUpModalCorrection();
    // Listen to sidebar toggle events
    window.addEventListener('sidebarToggle', (event: any) => {
      this.isSidebarCollapsed = event.detail.collapsed;
      localStorage.setItem('globalSidebarCollapsed', this.isSidebarCollapsed ? 'true' : 'false');
    });
  }

  setUpModalCorrection() {
    setInterval(() => this.findAndRemoveLockedModalBackground(), 300);
  }

  findAndRemoveLockedModalBackground() {
    var modalBackgrounds = $('.modal-backdrop.fade');
    for (var i = 0; i < modalBackgrounds.length; i++) {
      if (modalBackgrounds[i].classList.length == 2 && $('.modal.show').length == 0) {
        modalBackgrounds[i].remove();
      }
    }
    this.checkForResidualModalBackdrop();
  }

  checkForResidualModalBackdrop() {
    if ($('.modal-backdrop.fade').length > 0 && $('.modal.show').length == 0) {
      setTimeout(() => this.checkForResidualModalBackdropAgainAndRemove(), 300);
    }
  }
  checkForResidualModalBackdropAgainAndRemove() {
    var modalBackgrounds = $('.modal-backdrop.fade');
    if (modalBackgrounds.length > 0 && $('.modal.show').length == 0) {
      for (var i = 0; i < modalBackgrounds.length; i++) {
        modalBackgrounds[i].remove();
      }
    }
  }

  get isActionLinksMenuVisible(): boolean {
    return this.pcs.actionLinksPanelService.hasActionLinks;
  }

  get isBusy(): boolean {
    var result = this.pcs.busyService.isBusy;
    return result;
  }

  actionLinkClass(): string {
    var result = this.isActionLinksMenuVisible ? 'with-actionLinksBar' : 'without-actionLinksBar';
    return result;
  }

  toggleSidebar() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
    localStorage.setItem('globalSidebarCollapsed', this.isSidebarCollapsed ? 'true' : 'false');
    if (window.dispatchEvent) {
      window.dispatchEvent(new CustomEvent('sidebarToggle', { detail: { collapsed: this.isSidebarCollapsed } }));
    }
  }
}
